<template>
  <a-upload
      :action="actionUrl"
      :show-upload-list="false"
      :style="style"
      @change="onChange"
      accept="image/*"
      class="image-upload"
      list-type="picture-card"
      v-bind="$attrs" v-on="$listeners">
    <ResourceImg :id="$attrs.value" :resize="resize" v-if="$attrs.value"/>
    <div v-else>
      <a-icon :type="uploading ? 'loading' : 'plus'"/>
      <div class="ant-upload-text" v-if="title">{{ title }}</div>
    </div>
  </a-upload>
</template>

<script>
import api from "../utils/api";
import ResourceImg from "./ResourceImg";

export default {
  name: "ImageUpload",
  components: {ResourceImg},
  props: {
    title: {
      type: String,
      default: "点击上传",
    },
    width: Number,
    height: Number,
  },
  data() {
    return {
      uploading: false,
      actionUrl: api.v1.resource.createActionUrl,
    }
  },
  computed: {
    resize() {
      let resize = [];
      if (this.width > 0) {
        resize.push(`w_${this.width - 18}`);
      }
      if (this.height > 0) {
        resize.push(`h_${this.height - 18}`);
      }
      let type = this.width && this.height ? 8 : (this.width ? 2 : 3);
      return resize.length ? `m_${type},` + resize.join(",") : "";
    },
    style() {
      return `width: ${this.width}px; height: ${this.height}px;overflow: hidden;`;
    }
  },
  methods: {
    onChange(info) {
      if (info.file.status === "done") {
        const {error, result} = info.file.response;
        const {is_ok} = error;
        !is_ok && this.$message.error("上传失败");
        this.$emit("input", is_ok ? result.id : "");
      } else if (info.file.status === "error") {
        this.$message.error("上传失败");
      }
      this.uploading = (info.file.status === "uploading");
      this.$emit("change", info);
    }
  }
}
</script>

<style lang="less">
.image-upload {
  .ant-upload.ant-upload-select-picture-card {
    margin: 0;
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.45);

    .anticon {
      font-size: 26px;
    }
  }

  .ant-upload-text {
    margin-top: 5px;
  }
}
</style>
